import { v2blue400, v2blue500, v2neutral300 } from '@paypalcorp/pp-react'
import { greyBackgroundAndSmaller } from 'lib/styles/media-queries'

export const BOX_BORDER_STYLES = {
  border: `1px solid ${v2neutral300}`,
  borderRadius: '0.875rem',
  [greyBackgroundAndSmaller]: {
    border: 'none',
    borderRadius: 0,
  },
}

export const PRIMARY_TEXT_FONT_FAMILY = {
  fontFamily: 'PayPalSansBig-Regular, "Helvetica Neue", Arial, sans-serif',
}

export const LINK_STYLES = {
  '&:hover': {
    color: v2blue500,
  },
  color: v2blue400,
  fontFamily: 'PayPalSansBig-Medium, "Helvetica Neue", Arial, sans-serif',
}
